import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';
import { AuditService } from 'src/app/services/audit.service';
import { AuditStatusService } from 'src/app/services/Auditstatus.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { FinalChecklistService } from 'src/app/services/finalchecklist.service';
import { ToastService } from 'src/app/toast/toast.service';
import { ChecklistStatusModalComponent } from '../checklist-status-modal/checklist-status-modal.component';
import { isLinearGradient } from 'html2canvas/dist/types/css/types/image';
import { AllotService } from 'src/app/services/Allot.service';
import { Page } from 'src/app/classes/page';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
declare var bootstrap: any;

@Component({
  selector: 'app-viewchecklist',
  templateUrl: './viewchecklist.component.html',
  styleUrls: ['./viewchecklist.component.scss'],
})

export class ViewchecklistComponent {
  @ViewChild('deptRemarkForm') form!: NgForm;
  allData: any;
  iSocietyDetailsId: number | null = null;
  iSocietyDetailsTransId: number | null = null;
  lstAuditProcess: any;
  hideRemark: boolean = false;
  assetData: any[] = [];
  liabilityData: any[] = [];
  GovtData: boolean = false;
  loading = false;
  column: any[] = [];
  cols: any[] = [];
  originalBusinessList: any[] = [];
  lstBussinessUpgrades: any[] = [];
  isAuditChecked: boolean = false;
  trans: any;
  auditComment: any;
  otherParams: any;
  auditMember: any;
  allotData: any;
  services: any;
  fields: any;
  service: any;
  col: any[] = [];
  hidebutton: boolean = false;
  hideARemarks: boolean = false;
  lstBussinessUpgrade: any[] = [];
  roleid: number = 0;
  ddlStatus: string = '';
  isReadOnly: boolean = true;
  auditStatus: any = { sRemark: '' };
  download = false;
  Balancedatas: any[] = [];
  asOnDate: any;
  selectedViewRole: number = 1;
  auditorUploadedDocument: string = '';
  vrUploadedDocument: string = '';
  arUploadedDocument: string = '';
  DepUpload = {
    DepartmentalRemarkDocument: '',
    sDepartmentalRemark: '',
    DepartmentalRemarkFileName: '',
    documentExtension: '',
    transid: 0,
  };
  verRemarkMode: any;
  arRemarkMode: any;
  sbRemarkMode: any;
  page = new Page();
  rows: any[] = [];
  columns: any[] = [];


  isFirstRun = true;
  fileName: string = '';
  fileExtension: string = '';
  selectedFile: File | null = null;
  base64String2: string = '';
  base64String: string = '';
  cd: any;
  statusid: any;
  existingDeptRemark: boolean = false;
  existingARRemark: boolean = false;
  showRemarkDoc: boolean = false;
  showRemarArkDoc: boolean = false;
  hasGovernmentShareCapital = false;
  verifiermassgae: string = '';
  armassgae: string = '';
  ARnewUpload = {
    DepartmentalRemarkDocument: '',
    sDepartmentalRemark: '',
    DepartmentalRemarkFileName: '',
    documentExtension: '',
    transid: 0,
  };
  roleList: any[] = [
    { id: 1, name: 'Auditor' },
    { id: 2, name: 'Scrutiny' },
    { id: 3, name: 'AR' },
  ];
  roleFilterList: any[] = [];
  showUploadDocuemt: boolean = false;
  constructor(
    private modalService: NgbModal,
    private finalchecklist: FinalChecklistService,
    private router: Router,
    private auditstatus: AuditStatusService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private auditService: AuditService,
    private authService: AuthService,
    private config: ConfigService,
    private allotService: AllotService,
    private sanitizer: DomSanitizer,

  ) {
    this.page.pageNumber = 0;
    this.page.pageSize = 10;
    this.page.totalRecords = 0;
  }
  ngOnInit(): void {
    this.roleid = this.authService.currentUserValue.roleId;
    this.route.paramMap.subscribe((params) => {
      const transId = params.get('iSocietyDetailsTransId');
      this.iSocietyDetailsTransId = transId ? +transId : 0;
      const id = params.get('iSocietyDetailsId');
      this.iSocietyDetailsId = id ? +id : null;
      this.statusid = this.auditstatus.getStatus();

      if (
        this.iSocietyDetailsTransId !== null &&
        this.iSocietyDetailsId !== null
      ) {
        this.GetAllData(this.iSocietyDetailsTransId);
        this.GetServices(this.iSocietyDetailsId);
      } else {
        console.warn('Invalid or missing Society ID');
      }
    });
    const special = [10, 11, 12, 18, 19];

    if (this.statusid == 0 && this.roleid == 13) {
      this.roleFilterList = this.roleList.filter(x => x.id == 1);

    }

    else if (this.statusid == 0 && special.includes(this.roleid)) {
      this.roleFilterList = this.roleList.filter(x => x.id != 3);
    }
    else if (this.statusid == 4 && special.includes(this.roleid)) {
      this.roleFilterList = this.roleList.filter(x => x.id == 1);
    }
    else if (this.statusid == 3 && special.includes(this.roleid)) {
      this.roleFilterList = this.roleList;
    }
    else if (this.statusid == 1 && this.roleid == 13) {
      this.roleFilterList = this.roleList;
    }
    else if (this.statusid == 5 && this.roleid == 13) {
      this.roleFilterList = this.roleList.filter(x => x.id == 1);
    }

    else if (this.statusid == 2 && this.roleid == 13) {
      this.roleFilterList = this.roleList.filter(x => x.id == 1);

    }
    else if (this.statusid == 1 && special.includes(this.roleid)) {

      this.roleFilterList = this.roleList.filter(x => x.id != 3);

    }
    else if (this.statusid == 6 && special.includes(this.roleid)) {

      this.roleFilterList = this.roleList.filter(x => x.id == 1);

    }


    else if (this.statusid == 7 && this.roleid == 13) {
      this.roleFilterList = this.roleList.filter(x => x.id != 2);
    }
    else if (this.statusid == 3 && this.roleid == 13) {
      this.roleFilterList = this.roleList.filter(x => x.id != 2);
    }
    else if (this.statusid == 6 && this.roleid == 13) {
      this.roleFilterList = this.roleList.filter(x => x.id == 1);
    }


    this.column = [
      { prop: 'headName', name: 'Head' },
      { prop: 'subHeadName', name: 'Sub-Head' },
      { prop: 'subHeadOther', name: 'Other' },
      { prop: 'amount', name: 'Amount' },
    ];
    this.col = [
      { prop: 'labelName', name: 'Field Name' },
      { prop: 'value', name: 'Value' },
    ];

    this.cols = [
      { name: 'Role', prop: 'role' },
      { name: 'Action', prop: 'action' },
      { name: 'Date', prop: 'date' },
      { name: 'Remark', prop: 'remark' },
      { name: 'Document', prop: 'document' }
    ];


  }
  sUploadRD: any;
  sUploadpnL: any;
  UploadbalanceList: any;
  isShowArRemark: boolean = false;
  isShowVerRemark: boolean = false;
  isShowupdateButton: boolean = false;
  isShowAuditor: boolean = true;
  isremark: boolean = false;

  onChangeRole() {
    const special = [10, 11, 12, 18, 19];

    if (this.statusid == 0 && this.roleid == 13) {

      this.isShowArRemark = false;
      this.isShowVerRemark = false;
      this.isShowupdateButton = false;

    }
    else if (this.statusid == 0 && special.includes(this.roleid)) {

      if (this.selectedViewRole == 1) {
        this.isShowupdateButton = false;
        this.isShowArRemark = false;
        this.isShowVerRemark = false;

        this.isShowAuditor = true;



      }

      else if (this.selectedViewRole == 2) {
        this.isShowVerRemark = true;
        this.isShowupdateButton = true;

        this.isShowArRemark = false;
        this.isShowAuditor = false;
      }

    }


    else if (this.statusid == 5 && this.roleid == 13) {

      if (this.selectedViewRole == 1) {
        this.isShowupdateButton = false;
        this.isShowArRemark = false;
        this.isShowVerRemark = false;
        this.isShowAuditor = true;


      }
      else if (this.selectedViewRole == 2) {
        this.isShowVerRemark = true;
        this.isShowupdateButton = false;
        this.isShowArRemark = false;
        this.isShowAuditor = false;

      }
      else if (this.selectedViewRole == 3) {
        this.isShowVerRemark = false;
        this.isShowupdateButton = false;
        this.isShowArRemark = true;
        this.isShowAuditor = false;


      }
    }
    else if (this.statusid == 4 && special.includes(this.roleid)) {

      if (this.selectedViewRole == 1) {
        this.isShowupdateButton = false;
        this.isShowArRemark = false;

        this.isShowVerRemark = false;
        this.isShowAuditor = true;


      }
      else if (this.selectedViewRole == 2) {
        this.isShowVerRemark = true;
        this.isShowupdateButton = false;
        this.isShowArRemark = false;

        this.isShowAuditor = false;
      }
    }
    else if (this.statusid == 1 && this.roleid == 13) {

      this.isShowArRemark = false;
      this.isShowVerRemark = true;
      this.isShowupdateButton = false;
    }
    else if (this.statusid == 7 && this.roleid == 13) {
      if (this.selectedViewRole == 1) {
        this.isShowupdateButton = false;
        this.isShowArRemark = false;
        this.isShowVerRemark = false;
        this.isShowAuditor = true;


      }
      else if (this.selectedViewRole == 2) {
        this.isShowVerRemark = true;
        this.isShowupdateButton = false;

        this.isShowArRemark = false;
        this.isShowAuditor = false;
      }
      else if (this.selectedViewRole == 3) {
        this.isShowVerRemark = false;
        this.isShowupdateButton = true;
        this.isShowArRemark = true;
        this.isShowAuditor = false;
        this.isremark = true;

      }
    }

    else if (this.statusid == 1 && special.includes(this.roleid)) {

      if (this.trans?.iVerifierMoveForward == true) {
        if (this.selectedViewRole == 1) {
          this.isShowupdateButton = false;
          this.isShowArRemark = false;
          this.isShowVerRemark = false;
          this.isShowAuditor = true;
        } else if (this.selectedViewRole == 2) {
          this.isShowVerRemark = false;
          this.isShowupdateButton = false;
          this.isShowArRemark = false;
          this.isShowAuditor = false;

        }
      } else {
        if (this.selectedViewRole == 1) {
          this.isShowupdateButton = false;
          this.isShowArRemark = false;
          this.isShowVerRemark = false;
          this.isShowAuditor = true;
        } else if (this.selectedViewRole == 2) {
          this.isShowVerRemark = true;
          this.isShowupdateButton = true;
          this.isShowArRemark = false;
          this.isShowAuditor = false;
        }
      }
    }

    else if (this.statusid == 3 && this.roleid == 13) {


      if (this.selectedViewRole == 1) {
        this.isShowupdateButton = false;
        this.isShowArRemark = false;

        this.isShowVerRemark = false;
        this.isShowAuditor = true;


      }
      else if (this.selectedViewRole == 2) {
        this.isShowVerRemark = true;
        this.isShowupdateButton = false;
        this.isShowArRemark = false;

        this.isShowAuditor = false;




      }
      else if (this.selectedViewRole == 3) {
        this.isShowArRemark = true;
        this.isShowVerRemark = false;
        this.isShowAuditor = false;
        this.isShowupdateButton = true;

      }
    }
    else if (this.statusid == 2 && this.roleid == 13) {
      if (this.selectedViewRole == 1) {
        this.isShowupdateButton = false;
        this.isShowArRemark = false;
        this.isShowVerRemark = false;

        this.isShowAuditor = true;


      }
      else if (this.selectedViewRole == 2) {
        this.isShowVerRemark = true;
        this.isShowupdateButton = false;
        this.isShowArRemark = false;

        this.isShowAuditor = false;
      }
      else if (this.selectedViewRole == 3) {
        this.isShowVerRemark = false;
        this.isShowupdateButton = false;
        this.isShowArRemark = false;
        this.isShowAuditor = false;
        this.isremark = false
      }
    }
    else if (this.statusid == 6 && this.roleid == 13) {


      if (this.selectedViewRole == 1) {
        this.isShowupdateButton = false;
        this.isShowArRemark = false;

        this.isShowVerRemark = false;
        this.isShowAuditor = true;


      }
      else if (this.selectedViewRole == 2) {
        this.isShowVerRemark = true;
        this.isShowupdateButton = false;

        this.isShowArRemark = false;
        this.isShowAuditor = false;




      }
      else if (this.selectedViewRole == 3) {
        this.isShowArRemark = true;
        this.isShowVerRemark = false;
        this.isShowAuditor = false;
        this.isShowupdateButton = false;

      }
    }

    else if (this.statusid == 3 && special.includes(this.roleid)) {

      if (this.trans?.iVerifierMoveForward == true) {
        if (this.selectedViewRole == 1) {
          this.isShowupdateButton = false;
          this.isShowArRemark = false;
          this.isShowVerRemark = false;
          this.isShowAuditor = true;
        } else if (this.selectedViewRole == 2) {
          this.isShowVerRemark = true;
          this.isShowupdateButton = false;
          this.isShowArRemark = false;
          this.isShowAuditor = false;

        }
      } else {
        if (this.selectedViewRole == 1) {
          this.isShowupdateButton = false;
          this.isShowArRemark = false;
          this.isShowVerRemark = false;
          this.isShowAuditor = true;
        } else if (this.selectedViewRole == 2) {
          this.isShowVerRemark = true;
          this.isShowupdateButton = true;
          this.isShowArRemark = false;
          this.isShowAuditor = false;
        }
      }
    }


  }
  get hideVerifierDocumentButton(): boolean {
    return (this.statusid == 4 && this.roleid != 13) || (this.statusid == 7 && this.roleid == 13);
  }
  GetAllData(iSocietyDetailsTranID: number): void {
    this.finalchecklist.getlistDatas(iSocietyDetailsTranID).subscribe(
      (response) => {
        if (response.status === 200) {
          this.allData = response.data;
          const rawBalanceData = this.allData.finalBalanceSheet || [];
          this.trans = this.allData.societyDetailsTrans;
          this.auditComment = this.allData.auditComments;
          const data = this.auditComment;
          this.rows = [];

          if (data.verifierSendBackDate || data.verifierSendBackRemark || data.verifierSendBackDocument) {
            this.rows.push({
              role: 'Scrutiny',
              action: 'Send Back',
              date: data.verifierSendBackDate,
              remark: data.verifierSendBackRemark,
              document: data.verifierSendBackDocument || null
            });
          }

          if (data.verifierMoveForwardDate || data.verifierMoveForwardRemark || data.verifierMoveForwardDocument) {
            this.rows.push({
              role: 'Scrutiny',
              action: 'Move Forward',
              date: data.verifierMoveForwardDate,
              remark: data.verifierMoveForwardRemark,
              document: data.verifierMoveForwardDocument || '-'
            });
          }

          if (data.arSendBackDate || data.arSendBackRemark || data.arSendBackDocument) {
            this.rows.push({
              role: 'AR',
              action: 'Send Back',
              date: data.arSendBackDate,
              remark: data.arSendBackRemark,
              document: data.arSendBackDocument || '-'
            });
          }

          if (data.arMoveForwardDate || data.arMoveForwardRemark || data.arMoveForwardDocument) {
            this.rows.push({
              role: 'AR',
              action: 'Move Forward',
              date: data.arMoveForwardDate,
              remark: data.arMoveForwardRemark,
              document: data.arMoveForwardDocument || '-'
            });
          }

          if (data.arApprovedDate || data.arApprovedRemark || data.arApprovedDocument) {
            this.rows.push({
              role: 'AR',
              action: 'Approved',
              date: data.arApprovedDate,
              remark: data.arApprovedRemark,
              document: data.arApprovedDocument || '-'
            });
          }

          this.page.totalRecords = this.rows.length;
          this.loading = false;

          this.asOnDate = this.allData?.finalBalanceSheet?.[0]?.asOnDate || '';
          this.UploadbalanceList = this.allData?.finalBalanceSheet?.[0]?.sUploadbalanceList || '';
          this.sUploadRD = this.allData?.finalBalanceSheet?.[0]?.sUploadRD || '';

          this.sUploadpnL = this.allData?.finalBalanceSheet?.[0]?.sUploadpnL || '';

          this.auditorUploadedDocument = this.trans?.auditorUploadedDocument;
          this.arUploadedDocument = this.trans?.arDocument;

          this.vrUploadedDocument = this.trans?.verifierDocument;

          this.auditStatus = {
            sRemark: this.trans?.auditorRemark || '',
          };

          this.verRemarkMode = this.trans?.verifierDocument || ''

          if (
            this.roleid == 13 &&
            this.trans?.moveForwardToAR === true &&
            this.trans?.iVerifierRemark === false &&
            this.trans?.iVerifierMoveForward === false &&
            this.trans?.iARRemark === false
          ) {
            this.hidebutton = true;
            this.hideRemark = true;
            this.existingDeptRemark = true;
          } else if (
            this.roleid != 13 &&
            this.trans?.moveForwardToAR === true &&
            this.trans?.iVerifierMoveForward === false && this.trans?.iVerifierRemark === false
          ) {
            this.hidebutton = true;
            this.hideARemarks = false;
            this.hideRemark = false;
          } else if (
            this.roleid != 13 &&
            this.trans?.moveForwardToAR === true &&
            this.trans?.iVerifierRemark === true && this.trans?.iVerifierMoveForward == false
          ) {
            this.hidebutton = false;
            this.hideARemarks = false;
            this.hideRemark = true;

          }
          else if (
            this.roleid != 13 &&
            this.trans?.moveForwardToAR === true &&
            this.trans?.iVerifierRemark === true && this.trans?.iVerifierMoveForward == true
          ) {
            this.hidebutton = true;
            this.hideARemarks = false;
            this.hideRemark = true;
          }
          else if (
            this.roleid == 13 &&
            this.trans?.moveForwardToAR === true &&
            this.trans?.iVerifierRemark === true && this.trans?.iVerifierMoveForward == true && this.trans?.iARRemark == false
          ) {
            this.hidebutton = true;
            this.hideARemarks = false;
            this.hideRemark = false;
            this.existingDeptRemark = false;

          }
          else if (
            this.roleid == 13 &&
            this.trans?.moveForwardToAR === true &&
            this.trans?.iVerifierRemark === true && this.trans?.iVerifierMoveForward == true && this.trans?.iARRemark == true && this.trans?.iARMoveForward == false
          ) {
            this.hidebutton = false;
            this.hideARemarks = false;
            this.hideRemark = false;
            this.existingDeptRemark = false;
            this.download = false;

          }
          else if (
            this.roleid == 13 &&
            this.trans?.moveForwardToAR === true &&
            this.trans?.iVerifierRemark === true && this.trans?.iVerifierMoveForward == true && this.trans?.iARRemark == true && this.trans?.iARMoveForward == true  // Used this to hide thje Update Status
          ) {
            this.hidebutton = true;
            this.hideARemarks = false;
            this.hideRemark = false;
            this.existingDeptRemark = false;
            this.download = true;
            this.existingARRemark = true;

          }


          this.otherParams = this.allData.finalOtherParameters;
          this.auditMember = this.allData.auditMemberDetails;
          this.allotData = this.allData.auditAllotmentDetails;
          this.services = this.allData?.societyServiceDetails;
          this.service = this.services[0];
          //  this.fields = this.allData?.societyServiceDetailFields;
          const fields: any[] = this.allData?.societyServiceDetailFields || [];

          let checkIds: any[] = [];
          fields.forEach((field) => {

            if (field?.checkd && checkIds.indexOf(field.societyCheckID) === -1) {
              checkIds.push(field.societyCheckID);
            }
          });

          checkIds.forEach(async (item, index) => {
            await this.Getfields(item);

            if (index == checkIds.length - 1) {
              this.setValue(fields)
            }
          });



          this.Balancedatas = rawBalanceData.map((item: any) => ({
            headName: item.headName,
            subHeadName: item.subHeadName,
            subHeadOther: item.subHeadOther || '',
            amount: item.amount || 0,
            type: item.type || 0,
          }));
          this.assetData = this.Balancedatas.filter((item: any) => item.type === 2);
          this.liabilityData = this.Balancedatas.filter(
            (item: any) => item.type === 1
          );

          this.hasGovernmentShareCapital = this.Balancedatas.some(
            item => item.subHeadName === 'Government Share Capital'
          );
          this.GovtData = this.hasGovernmentShareCapital;


        } else {
          this.toastService.showError('Failed to fetch data');
        }
      },
      (error) => {
        console.error('Error fetching data', error);
        this.toastService.showError('Error occurred while fetching data');
      }
    );
  }

  setValue(fields: any) {
    setTimeout(() => {
      this.lstBussinessUpgrades.forEach((upgrade) => {
        const relatedFields = fields.filter(
          (f: any) => f.societyCheckID === upgrade.id
        );

        if (relatedFields.length > 0) {
          upgrade.checkd = true;

          relatedFields.forEach((field: any) => {
            // Map to lstServiceData
            upgrade.lstServiceData?.forEach((sub: any) => {
              if (sub.fieldID === field.fieldID && (sub.value == null || sub.value === '')) {
                sub.value = field.value;
              }
            });

            // Map to subFields
            upgrade.subFields?.forEach((sub: any) => {
              if (sub.subFieldID === field.subFieldID) {
                sub.value = field.value;
              }
            });

            // Map to groupedSubFields
            upgrade.groupedSubFields?.forEach((group: any) => {
              // Assign group heading if missing
              if (!group.heading && field.groupHeading) {
                group.heading = field.groupHeading;
              }

              // Set main field value
              if (group.fieldID === field.fieldID) {
                const inputType = group.inputType?.toLowerCase();

                if (inputType === 'dropdown') {
                  group.value = this.parseDropdownValue(inputType, field.value);
                }
                else if (inputType === 'boolean') {
                  const isGroupTrue = group.value === true || group.value === 'true';

                  if (isGroupTrue && Array.isArray(group.groupedConditionalFields)) {
                    group.groupedConditionalFields.forEach((subGroup: any) => {
                      if (Array.isArray(subGroup.fields)) {
                        subGroup.fields.forEach((condField: any) => {
                          const matched = relatedFields.find(
                            (f: any) => String(f.subFieldID) === String(condField.subFieldID)
                          );

                          if (matched && matched.hasOwnProperty('value')) {
                            condField.value = matched.value;
                          }
                        });
                      }
                    });
                  } else {
                    // When value is false or 'false' → hide fields and clear values
                    if (Array.isArray(group.groupedConditionalFields)) {
                      group.groupedConditionalFields.forEach((subGroup: any) => {
                        if (Array.isArray(subGroup.fields)) {
                          subGroup.fields.forEach((condField: any) => {
                            condField.value = '';
                          });
                        }
                      });
                    }
                  }
                }

                else {
                  group.value = field.value;
                }
              }

              group.groupedFields?.forEach((subGroup: any) => {
                subGroup.fields?.forEach((gfield: any) => {
                  if (gfield.fieldID === field.fieldID) {
                    gfield.value = field.value;
                  }
                });
              });

              group.conditionalFields?.forEach((condField: any) => {
                if (condField.fieldID === field.fieldID) {
                  condField.value = field.value;
                }
              });
            });
          });
        }
      });
    }, 1000);
  }
  parseDropdownValue(inputType: string, value: any): any {
    if (inputType?.toLowerCase() === 'dropdown' && value != null) {
      if (Array.isArray(value)) return value;

      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) return parsed;
        } catch (e) {
          return value.split(',').map(v => v.trim()).filter(Boolean);
        }
      }

      return [value];
    }
    return value;
  }
  calculateTotal(data: any[]): number {
    return data.reduce((sum, item) => sum + (parseInt(item.amount) || 0), 0);
  }

  get totalLiability(): number {
    return this.calculateTotal(this.liabilityData);
  }

  get totalAsset(): number {
    return this.calculateTotal(this.assetData);
  }
  back() {
    window.history.back();
  }
  downloadFile(fileName: string) {
    const fileUrl = this.config.getFileUrl() + 'BalanceSheet/' + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }
  Getfields(societyCheckID: number) {

    return this.finalchecklist.getfieldsDatas(societyCheckID).subscribe({
      next: (response) => {
        if (response.status === 200) {

          const selectedService = this.lstBussinessUpgrades.find(
            (ser) => ser.id === societyCheckID
          );

          if (selectedService) {
            selectedService.lstServiceData = response.data;

            this.finalchecklist.getsubfieldsDatas(societyCheckID).subscribe({
              next: (subResponse) => {
                selectedService.subFields = subResponse.data;

                const grouped = selectedService.lstServiceData.map(
                  (main: any) => {
                    if (!main?.inputType) {
                      return {
                        heading: main.labelName,
                        fieldID: main.fieldID,
                        value: main?.value || '-',
                        fields: selectedService.subFields.filter(
                          (sub: any) => sub.fieldID === main.fieldID
                        ),
                      };
                    }

                    else if (main?.inputType == 'dropdown') {
                      let options = selectedService.subFields
                        .filter((sub: any) => sub.fieldID === main.fieldID)
                        .map((f: any) => {
                          return f?.labelName || '';
                        });

                      return {
                        heading: main.labelName,
                        fieldID: main.fieldID,
                        options: options,
                        inputType: main?.inputType,
                      };

                    }
                    else if (main?.inputType === 'boolean') {


                      const booleanFields = selectedService.subFields.filter(
                        (sub: any) => sub.fieldID === main.fieldID
                      );

                      const groupedConditionalFields = booleanFields.reduce((acc: any[], field: any) => {
                        const heading = field.headingName || 'General';
                        let group = acc.find(g => g.heading === heading);
                        if (!group) {
                          group = { heading, fields: [] };
                          acc.push(group);
                        }
                        group.fields.push({
                          labelName: field.labelName,
                          headingName: field.headingName,
                          headingFlag: field.headingFlag,
                          inputType: 'number',
                          value: field.value || '-',
                          isRequired: field.isRequired || false,
                          fieldID: field.fieldID ?? field.iTBussinessFieldID ?? 0,
                          subFieldID: field.subFieldID ?? field.iTSubFieldID ?? field.subField?.id ?? 0,
                        });
                        return acc;
                      }, []);

                      return {
                        heading: main.labelName,
                        fieldID: main.fieldID,
                        inputType: 'boolean',
                        // value: main?.value,
                        value: true,
                        fields: [],
                        groupedConditionalFields,
                      };
                    }
                    else {
                      return main;
                    }
                  }
                );

                const groupedFieldIDs = grouped.flatMap(
                  (g: any) => g.fields && g.fields.map((f: any) => f.id)
                );

                selectedService.groupedSubFields = grouped;

              },
              error: (err) => {
                console.error('Error fetching sub-fields:', err);
              },
            });
          }
        }
        return
      },
      error: (error) => {
        console.error('Error fetching fields:', error);
      },
    });
  }
  GetServices(iSocietyDetailstId: number): void {
    this.iSocietyDetailsId = iSocietyDetailstId;
    this.finalchecklist.getservicesDatas(iSocietyDetailstId).subscribe(
      (response) => {
        if (response.status === 200) {
          this.lstBussinessUpgrades = response.data;

        }
      },
      (error) => {
        console.error("Error fetching data", error);
      }
    );
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileExtension = this.getFileExtension(file.name).toLowerCase();

      //const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
      const allowedExtensions = [ 'pdf'];

      if (allowedExtensions.includes(this.fileExtension)) {
        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 2) {
          this.toastService.showError('File size should be less than or equal to 2 MB');
          this.DepUpload.DepartmentalRemarkDocument = ''
          return;
        }

        this.selectedFile = file;
        this.convertToBase64(file, 1);
        this.cd.detectChanges();
      } else {
        this.toastService.showError('Invalid file type. Allowed types: pdf.');
        this.DepUpload.DepartmentalRemarkDocument = ''
      }
    }
  }
  onFileChange2(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileExtension = this.getFileExtension(file.name).toLowerCase();

      const allowedExtensions = [ 'pdf'];

      if (allowedExtensions.includes(this.fileExtension)) {
        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 2) {
          this.toastService.showError('File size should be less than or equal to 2 MB');
          this.ARnewUpload.DepartmentalRemarkDocument = ''
          return;
        }

        this.selectedFile = file;
        this.convertToBase64(file, 1);
        this.cd.detectChanges();
      } else {
        this.toastService.showError('Invalid file type. Allowed types:  pdf.');
        this.ARnewUpload.DepartmentalRemarkDocument = ''
      }
    }
  }
  reportUpload: string = '';
  arUpload: string = '';
  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (from === 1) {
        this.base64String = reader.result as string;
        this.reportUpload = reader.result as string;
        this.arUpload = reader.result as string;
      }
      if (from === 2) {
        this.base64String2 = reader.result as string;
      }
    };
  }
  resetfile()
  {
    this.reportUpload = '';
    this.arUpload = '';
  }

  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.');
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : '';
  }

  downloadDocument(filePath: string) {
    const relativePath = filePath.split('UploadedFiles\\')[1]?.replace(/\\/g, '/');

    if (relativePath) {
      const fileUrl = this.config.getFileUrl() + relativePath;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = relativePath.split('/').pop() || 'download';
      link.target = '_blank';
      link.click();
    } else {
      console.error('Invalid file path:', filePath);
    }
  }
  validateInput(event: KeyboardEvent, inputType: string): void {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);

    if (inputType === 'number') {
      if (!/^[0-9]$/.test(char)) {
        event.preventDefault();
      }
    } else if (inputType === 'string') {
      if (!/^[a-zA-Z0-9 ]$/.test(char)) {
        event.preventDefault();
      }
    }
    if (inputType === 'string' && event.target instanceof HTMLInputElement) {
      setTimeout(() => {
        const inputElement = event.target as HTMLInputElement;
        inputElement.value = inputElement.value.trim();
      });
    }
  }
  onPaste(event: ClipboardEvent, inputType: string): void {
    const pastedData = event.clipboardData?.getData('text') || '';

    if (inputType === 'number') {
      if (!/^\d+$/.test(pastedData)) {
        event.preventDefault();
      }
    }

    if (inputType === 'string') {
      if (!/^[a-zA-Z0-9 ]+$/.test(pastedData)) {
        event.preventDefault();
      }
    }
  }

  formatDateToYYYYMMDD(dateStr: string | null | undefined): string {
    if (
      !dateStr ||
      dateStr.startsWith('0001-01-01') ||
      dateStr.startsWith('1900-01-01')
    ) {
      return '';
    }

    const date = new Date(dateStr);

    if (isNaN(date.getTime())) {
      return '';
    }

    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  base64ToBlob(base64: any, contentType = "", sliceSize = 512): Blob {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
  selectedContent: string = '';
  base64Pdf: SafeResourceUrl = '';
  previewFile(file: any, model: any): void {

    if (!file) return;
    const blob = this.base64ToBlob(file, "application/pdf");
    this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    this.openModals(model)
  }
  openModals(content: string): void {
    this.selectedContent = content;
    const modalElement = document.getElementById(content);
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }

  resetStatus() {
    this.ddlStatus = '';
    this.selectedViewRole = 0;
  }

  onSubmitRemark(form: NgForm) {
    this.addRemark(form);
    this.updateStatus(form)
    this.router.navigate([`/dashboard`])




  }

  remark = ''
  isStatusUpdating = false;

  addRemark(form: NgForm) {
    if (!form || form.invalid) {
      return;
    }
    this.isStatusUpdating = true;
    const auditCommentPayload = {
      iSocietyDetailTransID: this.iSocietyDetailsTransId,
      iAllotAuditorID: this.trans.iAllotAuditorID,
      iRoleID: this.roleid,
      flagID: 0,
      VerifierMoveForwardRemark: '',
      VerifierMoveForwardDocument: '',
      VerifierSendBackRemark: '',
      VerifierSendBackDocument: '',
      ARMoveForwardRemark: '',
      ARMoveForwardDocument: '',
      ARSendBackRemark: '',
      ARSendBackDocument: '',
      ARApprovedRemark: '',
      ARApprovedDocument: '',
      FileName: '',
      documentExtension: ''
    };
    this.ARnewUpload.DepartmentalRemarkDocument = this.base64String || '';
    this.ARnewUpload.DepartmentalRemarkFileName = this.fileName;
    this.ARnewUpload.documentExtension = this.fileExtension;
    this.DepUpload.DepartmentalRemarkDocument = this.base64String || '';
    this.DepUpload.DepartmentalRemarkFileName = this.fileName;
    this.DepUpload.documentExtension = this.fileExtension;
    if (this.ddlStatus === 'MoveForwardToAR') {
      auditCommentPayload.flagID = 1;
      auditCommentPayload.VerifierMoveForwardRemark = this.DepUpload?.sDepartmentalRemark || '';
      auditCommentPayload.documentExtension = this.DepUpload.documentExtension || '';
      auditCommentPayload.FileName = this.DepUpload.DepartmentalRemarkFileName || '';
      auditCommentPayload.VerifierMoveForwardDocument = this.DepUpload?.DepartmentalRemarkDocument || '';
    } else if (this.ddlStatus === 'InSendBack') {
      auditCommentPayload.flagID = 2;
      auditCommentPayload.VerifierSendBackRemark = this.DepUpload?.sDepartmentalRemark || '';
      auditCommentPayload.documentExtension = this.DepUpload.documentExtension || '';
      auditCommentPayload.FileName = this.DepUpload.DepartmentalRemarkFileName || '';
      auditCommentPayload.VerifierSendBackDocument = this.DepUpload?.DepartmentalRemarkDocument || '';
    } else if (this.ddlStatus === 'MoveForwardAudit') {
      auditCommentPayload.flagID = 1;
      auditCommentPayload.ARMoveForwardRemark = this.ARnewUpload?.sDepartmentalRemark || '';
      auditCommentPayload.documentExtension = this.ARnewUpload.documentExtension || '';
      auditCommentPayload.FileName = this.ARnewUpload.DepartmentalRemarkFileName || '';
      auditCommentPayload.ARMoveForwardDocument = this.ARnewUpload?.DepartmentalRemarkDocument || '';
    } else if (this.ddlStatus === 'SendBackAudit') {
      auditCommentPayload.flagID = 2;
      auditCommentPayload.ARSendBackRemark = this.ARnewUpload?.sDepartmentalRemark || '';
      auditCommentPayload.documentExtension = this.ARnewUpload.documentExtension || '';
      auditCommentPayload.FileName = this.ARnewUpload.DepartmentalRemarkFileName || '';
      auditCommentPayload.ARSendBackDocument = this.ARnewUpload?.DepartmentalRemarkDocument || '';
    } else if (this.ddlStatus === 'MoveForwardToARApproved') {
      auditCommentPayload.flagID = 3;
      auditCommentPayload.ARApprovedRemark = this.ARnewUpload?.sDepartmentalRemark || '';
      auditCommentPayload.documentExtension = this.ARnewUpload.documentExtension || '';
      auditCommentPayload.FileName = this.ARnewUpload.DepartmentalRemarkFileName || '';
      auditCommentPayload.ARApprovedDocument = this.ARnewUpload?.DepartmentalRemarkDocument || '';
    }

    this.auditService.addAuditComment(auditCommentPayload).subscribe(
      (res) => {
        this.isStatusUpdating = false;

        if (
          this.iSocietyDetailsTransId !== null &&
          this.iSocietyDetailsId !== null
        ) {
          this.GetAllData(this.iSocietyDetailsTransId);
        }

        form.reset();



      },
      (err) => {
        this.toastService.showError('Failed to save audit comment: ' + err.message);
        this.isStatusUpdating = false;
      }
    );


  }
  updateStatus(form: NgForm) {
    if (!form || form.invalid) {
      return;
    }
    const data = {
      transID: this.iSocietyDetailsTransId,
      iSocietyDetailID: this.iSocietyDetailsId,
      AuditStatus: this.ddlStatus,
      iAllotAuditorID: this.trans.iAllotAuditorID,
      iRoleID: 0,
      iUserID: 0,
      remark: ''

    };
    if (this.ddlStatus === 'InSendBack') {
      const sendBackData = {
        iSocietyDetailsTranID: this.iSocietyDetailsTransId,
        senderRoleID: this.roleid
      };

      this.auditService.auditSentBack(sendBackData).subscribe(
        (response: any) => {
          this.router.navigate([`/dashboard`])

          //this.toastService.showSuccess(response.message);
          form.reset();
          this.resetfile();
        },
        (error: any) => {
          this.toastService.showError('Error during send back: ' + error.message);
        }
      );
    }
    if (this.ddlStatus === 'MoveForwardToAuditMoveForward') {
      const ForwardData = {
        iSocietyTransID: this.iSocietyDetailsTransId,
      };

      this.auditService.auditMoveForward(ForwardData).subscribe(
        (response: any) => {
          this.router.navigate([`/dashboard`])

          this.toastService.showSuccess(response.message);
          form.reset();
        },
        (error: any) => {
          this.toastService.showError('Error during send back: ' + error.message);
        }
      );
    }

    if (this.ddlStatus === 'MoveForwardAudit' || this.ddlStatus === 'SendBackAudit') {
      const senddata = {
        iSocietyDetailsTranID: this.iSocietyDetailsTransId,
        roleID: 0,
        UserID: 0,
        action: this.ddlStatus,
        StatusID: this.statusid,
        iAllotAuditorID: this.trans.iAllotAuditorID,


      };
      this.finalchecklist.sendbackAR(senddata).subscribe(
        (response) => {
          //this.toastService.showSuccess(response.message);
          this.router.navigate([`/dashboard`])
        },
        (error) => {
          this.toastService.showError(
            error.message || 'Error while rejecting the request.'
          );
        }
      );

    }

    else {
      this.auditService.updateDepartmentalStatus(data).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          form.reset();
          if (this.roleid === 13) {
            this.router.navigate(['/dashboard']);
          } else {
            this.router.navigate(['/dashboard']);
          }
        },
        (error) => {
          this.toastService.showError('Error updating remarks: ' + error.message);
        }
      );
    }
  }


  previewAudit(): void {
    this.router.navigate(['/audit/auditpreview', this.iSocietyDetailsId, this.iSocietyDetailsTransId]);
  }
  ViewStatusModal() {
    this.modalService.open(ChecklistStatusModalComponent, {
      size: 'lg'
    })

  }

  filteredStatus: any;
  //Method for get View data from table by Id
  auditStatusProcess(iSocietyDetailsId: number, iAllotAuditorID: number): void {
    this.allotService.getAllotAuditorStatus(iSocietyDetailsId, iAllotAuditorID).subscribe(
      (response: any) => {
        this.filteredStatus = response.data;
      },
      (error: { message: string; }) => {
        this.toastService.showError(error.message);
      }
    );
  }

}
